import Vue from 'vue'

export const getUser = {
  methods: {
    getUser () {
      let element = document.getElementById('ask_info')
      Vue.prototype.$ask = {
        user_id: element.dataset.id,
        brand: element.dataset.brand,
        url: element.dataset.url,
        lang: element.dataset.lang,
        ip: element.dataset.ip,
        country: element.dataset.country
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/getUser.js